var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-padding fit" }, [
    _c("div", { staticClass: "q-pb-sm" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Drivers License Number",
                  value: _vm.detailsForm.driversLicenseNumber,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "driversLicenseNumber",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "Role",
                  value: _vm.detailsForm.role,
                  options: _vm.roleOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateDetailsForm({ field: "role", value: val })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "Status",
                  value: _vm.detailsForm.status,
                  options: _vm.statusOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateDetailsForm({
                      field: "status",
                      value: val
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "q-py-sm" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "First Name",
                  value: _vm.detailsForm.firstName,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "firstName",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Middle Name",
                  value: _vm.detailsForm.middleName,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "middleName",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Last Name",
                  value: _vm.detailsForm.lastName,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "lastName",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-2" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "Suffix",
                  value: _vm.detailsForm.suffix,
                  options: _vm.suffixOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateDetailsForm({
                      field: "suffix",
                      value: val
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Social Security Number",
                  value: _vm.detailsForm.ssn,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "ssn",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-3" },
            [
              _c("q-datetime", {
                attrs: {
                  type: "date",
                  "float-label": "Date of Birth",
                  format: "MM/D/YYYY",
                  value: _vm.detailsForm.dob,
                  required: ""
                },
                on: {
                  input: function(val) {
                    return _vm.updateDetailsForm({ field: "dob", value: val })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-3" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "Gender",
                  value: _vm.detailsForm.gender,
                  options: _vm.genderOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateDetailsForm({
                      field: "gender",
                      value: val
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-6" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Email",
                  value: _vm.detailsForm.email,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "email",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-6" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Phone",
                  value: _vm.detailsForm.phone,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "phone",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "q-py-sm" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-12" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Address 1",
                  value: _vm.detailsForm.address1,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "address1",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-12" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Address 2",
                  value: _vm.detailsForm.address2,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "address2",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "City",
                  value: _vm.detailsForm.city,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "city",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-select", {
                attrs: {
                  "float-label": "State",
                  value: _vm.detailsForm.state,
                  options: _vm.stateOptions
                },
                on: {
                  change: function(val) {
                    return _vm.updateDetailsForm({ field: "state", value: val })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { staticClass: "q-pa-md col-4" },
            [
              _c("q-input", {
                attrs: {
                  "float-label": "Zip",
                  value: _vm.detailsForm.zip,
                  required: ""
                },
                on: {
                  keyup: function($event) {
                    $event.stopPropagation()
                    _vm.updateDetailsForm({
                      field: "zip",
                      value: $event.target.value
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }